var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"how-it-works-info"},[_c('no-ssr',[_c('b-popover',{attrs:{"target":_vm.targetId,"container":_vm.targetId,"triggers":"hover","html":true,"placement":"bottomright"}},[_c('how-it-works-info')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }